// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booked-item[data-v-59e0173a]{margin-top:22px}.booked-item__time[data-v-59e0173a]{color:var(--q4s-white);text-transform:uppercase;font-size:12px;letter-spacing:.6px;background-color:var(--q4s-neutral-500);border-radius:4px;margin-bottom:25px;padding:5px 8px;font-weight:600;display:inline-block}.booked-item__time-now[data-v-59e0173a]{background-color:var(--q4s-ink)}", ""]);
// Exports
module.exports = exports;
